export default __webpack_public_path__ + "static/media/trailer-two-axles.14a25ca0.svg";